import toast from 'react-hot-toast';

/**
 * Custom toast utility with predefined styles and messages
 */

// Success notifications
export const showSuccessToast = (message: string) => {
  toast.success(message, {
    duration: 3000,
  });
};

// Error notifications
export const showErrorToast = (message: string) => {
  toast.error(message, {
    duration: 4000,
  });
};

// Info notifications
export const showInfoToast = (message: string) => {
  toast(message, {
    duration: 3000,
    icon: 'ℹ️',
  });
};

// Loading notifications
export const showLoadingToast = (message: string) => {
  return toast.loading(message, {});
};

// Warning notifications
export const showWarningToast = (message: string) => {
  toast(message, {
    duration: 4000,
    icon: '⚠️',
  });
};

// Promise-based toast (useful for async operations)
export const showPromiseToast = <T>(
  promise: Promise<T>,
  messages: {
    loading: string;
    success: string;
    error: string;
  }
) => {
  return toast.promise(
    promise,
    {
      loading: messages.loading,
      success: messages.success,
      error: messages.error,
    },
    {
      style: {
        minWidth: '250px',
      },
      success: {
        duration: 3000,
        style: {
          background: '#10B981',
          color: '#fff',
        },
      },
      error: {
        duration: 4000,
        style: {
          background: '#EF4444',
          color: '#fff',
        },
      },
    }
  );
};

// Custom toast with custom options
export const showCustomToast = (message: string, options?: Parameters<typeof toast>[1]) => {
  toast(message, options);
};

// Dismiss a specific toast
export const dismissToast = (toastId: string) => {
  toast.dismiss(toastId);
};

// Dismiss all toasts
export const dismissAllToasts = () => {
  toast.dismiss();
};
